import { findIndex, get } from 'lodash'
import { actions } from 'react-redux-form'

export const VIDEO_RESPONSE_UPLOADING = 'VIDEO_RESPONSE_UPLOADING'
export const VIDEO_RESPONSE_UPLOAD_FINISHED = 'VIDEO_RESPONSE_UPLOAD_FINISHED'
export const RECORDING_TOGGLE = 'RECORDING_TOGGLE'
export const OPEN_QUESTION_SET = 'OPEN_QUESTION_SET'
export const BG_OPTIONS_SET = 'BG_OPTIONS_SET'

/**
 * Update video response for applicant/candidate
 * @param  {string} context       type of model we are working with: application or candidate
 * @param  {object} VideoResponse VideoResponse we are updating
 * @param  {object} data          new data
 */
export const updateVideoResponse = (context, VideoResponse, data) => {
  // sanity check
  if (['application', 'candidate', 'messages'].indexOf(context) < 0) {
    throw new Error('Invalid context')
  }

  return (dispatch, getState) => {
    const state = getState()
    const questionId = (typeof VideoResponse !== 'undefined' ? VideoResponse.questionId : null)
    // We make assumption that one question can have only one response from applicant
    const index = findIndex(get(state, context).videoResponses, { questionId })
    // If response exists update otherwise push it as new to the list
    if (index > -1) {
      dispatch(actions.merge(`${context}.videoResponses[${index}]`, data))
    } else {
      dispatch(actions.push(`${context}.videoResponses`, { ...VideoResponse, ...data }))
    }
  }
}

export const deleteVideoResponse = (context, VideoResponse, data) => {
  // sanity check
  if (['application', 'candidate', 'messages'].indexOf(context) < 0) {
    throw new Error('Invalid context')
  }

  return (dispatch, getState) => {
    const state = getState()
    const questionId = (typeof VideoResponse !== 'undefined' ? VideoResponse.questionId : null)
    // We make assumption that one question can have only one response from applicant
    const index = findIndex(get(state, context).videoResponses, { questionId })
    // If response exists update otherwise push it as new to the list
    if (index > -1) {
      dispatch(actions.change(`${context}.videoResponses[${index}]`, data))
    } else {
      dispatch(actions.push(`${context}.videoResponses`, { ...VideoResponse, ...data }))
    }
  }
}

export const videoUploadInProgress = payload => ({ type: VIDEO_RESPONSE_UPLOADING, payload })

export const videoUploadFinished = payload => ({ type: VIDEO_RESPONSE_UPLOAD_FINISHED, payload })

export const toggleRecordingState = payload => ({ type: RECORDING_TOGGLE, payload })

export const setOpenQuestion = payload => ({ type: OPEN_QUESTION_SET, payload })

export const setBgOptions = payload => ({ type: BG_OPTIONS_SET, payload })
